import { useState, useEffect } from 'react';

export type UseMutationObserverProps = {
  element: Element | Node | null;
  callback: MutationCallback;
  options: MutationObserverInit;
}

export const useMutationObserver = (
    element,
    callback,
    options = {},
  ) => {

  const [observer, setObserver] = useState(null);

  useEffect(() => {
    if (typeof window !== 'undefined' && window.document?.createElement) {
      setObserver(new MutationObserver(callback));
    }
  }, [])

  useEffect(() => {
    if (!observer || !element) {
      return;
    }
    observer.observe(element, options);
    return () => {
      observer.disconnect();
    }
  }, [observer, element, options])

}